"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnsReferencingFieldQueryGrid = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    if (resultData && resultData.fields && resultData.fields[0] && resultData.fields[0].__typename === 'ColumnField') {
        return resultData.fields[0].columnsConnection;
    }
    return null;
}
function mapResultNode(node) {
    return {
        id: node.id,
        name: node.name,
        tableId: node.table && node.table.id || '',
        tableName: node.table && node.table.name || '',
        typename: node.table && node.table.__typename || '',
        tableVizportalUrlId: node.table && node.table.__typename === 'VirtualConnectionTable'
            ? node.table.vizportalUrlId
            : null,
    };
}
function urlForLink(urls, rowData) {
    var _a;
    switch (rowData.typename) {
        case 'DatabaseTable':
            return urls.catalogTableColumnPath(rowData.tableId, rowData.id);
        case 'VirtualConnectionTable':
            return urls.virtualConnectionTableLineageFieldPath((_a = rowData.tableVizportalUrlId) !== null && _a !== void 0 ? _a : rowData.tableId, rowData.id);
        case 'CustomSQLTable':
            return null;
        default:
            return null;
    }
}
function nameForLink(rowData) {
    if (rowData.name === null) {
        return null;
    }
    return catalog_messages_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.tableName });
}
function ColumnsReferencingFieldQueryGrid(props) {
    const emptyGridMessage = catalog_messages_1.Messages.EmptyFieldUsedByColumnsGridMessage();
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.ColumnsReferencingFieldDocument, partialQueryVariables: { fieldId: props.fieldId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: urlForLink, name: nameForLink }))));
}
exports.ColumnsReferencingFieldQueryGrid = ColumnsReferencingFieldQueryGrid;
//# sourceMappingURL=ColumnsReferencingFieldQueryGrid.js.map